import { AxiosResponse } from "axios";
import { SearchgridTemplateRequest } from "@/main/models/request/templateEmailNotificationCompanyRequest";
import { PaginationResponse } from "@/main/models/common/paginationResponse";
import { SearchgridTemplateResponse } from "@/main/models/response/templateEmailNotificationCompanyResponse";

export abstract class ITemplateEmailNotificationCompanyApi {
	abstract getSearchGridTemplate(
		request: SearchgridTemplateRequest,
	): Promise<AxiosResponse<PaginationResponse<SearchgridTemplateResponse>>>;
}
